const utilsMixin = {
  methods: {
    isNullOrUndefined (input) {
      return input === null || input === undefined
    },
    generateId () {
      return '_' + Math.random().toString(36).substr(2, 9)
    }
  }
}

export default utilsMixin
